import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography
} from '@mui/material';
import { useState } from 'react';
import { Save } from '@mui/icons-material';
import { RootState } from 'src/redux-store/appStore';
import { useDispatch, useSelector } from 'react-redux';
import { updatePlumbing } from 'src/redux-store/slices/constructionFormSlice';
import toast from 'react-hot-toast';
import { httpRequest } from 'src/services/httpRequest';
import { useParams } from 'react-router-dom';

interface WorkItem {
  name?: string;
  Item: string;
  Quantity?: number;
  check: boolean;
  Fee: number;
  WallArea?: string | null;
  FenceHeight?: string | null;
  SignType?: string | null;
  SignArea?: string | null;
  PoolItem?: string | null;
  PoolArea?: string | null;
  Type?: string | null;
  RoofReplacementType?: string | null;
}

interface CostOfWorkProps {
  onBack: () => void;
  onNext: () => void;
  townshipID: number;
}

const CostOfWork: React.FC<CostOfWorkProps> = ({ onBack, onNext,townshipID }) => {
  const dispatch = useDispatch();
  const {townshipId}= useParams();
  const [otherWorkItemsName, setOtherWorkItemsName] = useState([
    { Item: '', Quantity: 0, Fee: 0, check: true, Type: 'other' }
  ]);
  const workItems = useSelector(
    (state: RootState) => state.constructionFormSlice?.Plumbing?.WorkItems
  );

  const subCodesFormData = useSelector(
    (state: RootState) => state.constructionFormSlice.Plumbing
  );

  const handleChangePlumbingCharacteristics = (field, value: string) => {
    const updatedCharacteristics = { ...subCodesFormData, [field]: value };

    dispatch(updatePlumbing(updatedCharacteristics));
  };

  const handleWorkItemChange = (
    index: number,
    field: keyof WorkItem,
    value: string | boolean
  ) => {
    const updatedWorkItems = [...workItems];
    updatedWorkItems[index] = { ...updatedWorkItems[index], [field]: value };
    // Update only the nested property
    if (isNaN(Number(value))) {
      dispatch(
        updatePlumbing({
          WorkItems: updatedWorkItems
        })
      );
    } else if (Number(value) >= 0) {
      dispatch(
        updatePlumbing({
          WorkItems: updatedWorkItems
        })
      );
    }
  };

  async function getPlumbingFees() {
    const payload = {
      UseGroup: 'R-3, R-5',
      IsResidential: false,
      CertificateType: 'Clearance',
      WorkItems: workItems,
      TownshipID : townshipId || townshipID,
    };
    const response = await httpRequest(
      'POST',
      `/construction/plumbing/get_plumbing_fees`,
      payload
    );

    if (response?.status === 'success') {
      const data = response?.data || '';
      const dataDetails = {
        'Plumbing Size': data['Plumbing Size'],
        'Certification Cost': data['Certification Cost'],
        totalFee: data.totalFee,
        summary: data.summary
      };
      dispatch(
        updatePlumbing({
          getAllFee: dataDetails
        })
      );
      // setLoading(false);
    } else {
      // setLoading(false);
      toast.error(response?.message);
    }
  }

  return (
    <Grid container gap={3}>
      {/* Left Grid - Estimation fields */}
      <Grid
        item
        xs={12}
        key={`${'item.item'} + index`}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2
        }}
        mt={3}
      >
        <Typography variant="h5">Estimated Cost Of Work</Typography>
        <Grid container spacing={3} sx={{ mb: 3 }}>
          <Grid item xs={12} sm={6}>
            <Box>
              <TextField
                fullWidth
                label={
                  <span>
                    Plumbing Work Cost <span style={{ color: 'red' }}>*</span>
                  </span>
                }
                type="number"
                value={subCodesFormData?.TotalEstimateCost || ''}
                variant="outlined"
                onChange={(e) =>
                  handleChangePlumbingCharacteristics(
                    'TotalEstimateCost',
                    e.target.value as string
                  )
                }
              />
            </Box>
          </Grid>
        </Grid>
      </Grid>
      {/* Right Grid - Work items */}
      <Grid item md={12} sm={12}>
        <Typography variant="h5">Construction Work items</Typography>
        <br />
        <Grid container spacing={3}>
          {workItems?.map((item, index) => (
            <Grid
              item
              xs={12}
              md={3}
              sm={4}
              key={`${item.Item}-${index}`}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 2
              }}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    checked={item.check}
                    onChange={(e) =>
                      handleWorkItemChange(index, 'check', e.target.checked)
                    }
                  />
                }
                label={item.Item}
              />

              {item.check && (
                <>
                  {item?.FieldType !== 'Select' && (
                    <TextField
                      type="number"
                      fullWidth
                      label="Quantity"
                      variant="outlined"
                      value={item.Quantity === 0 ? '' : item.Quantity}
                      onChange={(e) =>
                        handleWorkItemChange(index, 'Quantity', e.target.value)
                      }
                    />
                  )}

                  {item.Item === 'Sewer Pumps' && (
                    <>
                      <FormControl fullWidth>
                        <InputLabel>Select item</InputLabel>
                        <Select
                          label="Select item"
                          value={item?.Type || ''}
                          onChange={(e) =>
                            handleWorkItemChange(
                              index,
                              'Type',
                              e.target.value as string
                            )
                          }
                        >
                          <MenuItem value="Residential Single">
                            Residential Single
                          </MenuItem>
                          <MenuItem value="Residential Multifixture">
                            Residential Multifixture
                          </MenuItem>
                          <MenuItem value="Commercial">Commercial</MenuItem>
                        </Select>
                      </FormControl>
                    </>
                  )}

                  {item.Item === 'Interceptor' && (
                    <>
                      <FormControl fullWidth>
                        <InputLabel>Select item</InputLabel>
                        <Select
                          label="Select item"
                          value={item?.Type || ''}
                          onChange={(e) =>
                            handleWorkItemChange(
                              index,
                              'Type',
                              e.target.value as string
                            )
                          }
                        >
                          <MenuItem value="Interior">Interior</MenuItem>
                          <MenuItem value="Exterior">Exterior</MenuItem>
                        </Select>
                      </FormControl>
                    </>
                  )}

                  {item.Item === 'Water Cooled' && (
                    <>
                      <FormControl fullWidth>
                        <InputLabel>Select item</InputLabel>
                        <Select
                          label="Select item"
                          value={item?.Type || ''}
                          onChange={(e) =>
                            handleWorkItemChange(
                              index,
                              'Type',
                              e.target.value as string
                            )
                          }
                        >
                          <MenuItem value="Refrigerator Unit">
                            Refrigerator Unit
                          </MenuItem>
                          <MenuItem value="Residential AC">
                            Residential AC
                          </MenuItem>
                          <MenuItem value="Commercial AC">
                            Commercial AC
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </>
                  )}
                </>
              )}
            </Grid>
          ))}
        </Grid>
        <br />
        <br />

        {/* Add More Items */}
        <Grid
          item
          xs={12}
          key={`${'item.item'} + index`}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 2
          }}
        >
          <Typography variant="h5">Add More Items</Typography>
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'column', md: 'row' },
              gap: 2
            }}
          >
            <TextField
              name="itemName"
              label="Other item name"
              fullWidth
              value={otherWorkItemsName[0].Item}
              onChange={(e) => {
                const updatedWorkItems = [...otherWorkItemsName];
                updatedWorkItems[0].Item = e.target.value;
                setOtherWorkItemsName(updatedWorkItems);
              }}
            />

            <TextField
              name="Quantity"
              label="Quantity"
              type="number"
              fullWidth
              value={otherWorkItemsName[0].Quantity}
              onChange={(e) => {
                if (Number(e.target.value) >= 0) {
                  const updatedWorkItems = [...otherWorkItemsName];
                  updatedWorkItems[0].Quantity = Number(e.target.value);
                  setOtherWorkItemsName(updatedWorkItems);
                }
              }}
            />

            <TextField
              name="size"
              label="Fee"
              type="number"
              fullWidth
              value={otherWorkItemsName[0].Fee}
              onChange={(e) => {
                if (Number(e.target.value) >= 0) {
                  const updatedWorkItems = [...otherWorkItemsName];
                  updatedWorkItems[0].Fee = Number(e.target.value);
                  setOtherWorkItemsName(updatedWorkItems);
                }
              }}
            />

            <Button
              variant="contained"
              color={'primary'}
              startIcon={<Save />}
              onClick={() => {
                if (otherWorkItemsName[0].Item !== '') {
                  dispatch(
                    updatePlumbing({
                      WorkItems: [...workItems, ...otherWorkItemsName]
                    })
                  );
                  setOtherWorkItemsName([
                    {
                      Item: '',
                      Quantity: 0,
                      Fee: 0,
                      check: true,
                      Type: 'other'
                    }
                  ]);
                }
              }}
              fullWidth
            >
              {'Add Items'}
            </Button>
          </Box>
        </Grid>
        <br />

        <Grid
          item
          xs={12}
          key={`${'item.item'} + index`}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 2
          }}
          mt={3}
        >
          <Typography variant="h5">Plumbing Characteristics</Typography>
          <Grid container spacing={3} sx={{ mb: 3 }}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Building Sewer Size"
                value={subCodesFormData?.BuildingSewerSize || ''}
                variant="outlined"
                onChange={(e) =>
                  handleChangePlumbingCharacteristics(
                    'BuildingSewerSize',
                    e.target.value as string
                  )
                }
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel id="sewer-type-label">
                  Public Sewer/Private Septic
                </InputLabel>
                <Select
                  labelId="sewer-type-label"
                  value={subCodesFormData?.SewerType}
                  label="Public Sewer/Private Septic"
                  onChange={(e) =>
                    handleChangePlumbingCharacteristics(
                      'SewerType',
                      e.target.value as string
                    )
                  }
                >
                  <MenuItem value="">
                    <em>Select...</em>
                  </MenuItem>
                  <MenuItem value="Public Sewer">Public Sewer</MenuItem>
                  <MenuItem value="Private Septic">Private Septic</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Water Service Size"
                value={subCodesFormData?.WaterServiceSize}
                onChange={(e) =>
                  handleChangePlumbingCharacteristics(
                    'WaterServiceSize',
                    e.target.value as string
                  )
                }
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel id="water-type-label">
                  Public Water/Private Well
                </InputLabel>
                <Select
                  labelId="water-type-label"
                  value={subCodesFormData?.WaterType}
                  label="Public Water/Private Well"
                  onChange={(e) =>
                    handleChangePlumbingCharacteristics(
                      'WaterType',
                      e.target.value as string
                    )
                  }
                >
                  <MenuItem value="">
                    <em>Select...</em>
                  </MenuItem>
                  <MenuItem value="Public Water">Public Water</MenuItem>
                  <MenuItem value="Private Well">Private Well</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {/* Form Action Buttons */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          gap: 2,
          mt: 3,
          width: '100%'
        }}
      >
        <Button onClick={onBack} variant="contained" color="inherit">
          Back
        </Button>
        <Button
          onClick={async () => {
            await getPlumbingFees();
            onNext();
          }}
          variant="contained"
        >
          Save
        </Button>
      </Box>
    </Grid>
  );
};

export default CostOfWork;
